import React from 'react'
import Hidden from '@material-ui/core/Hidden'

import SmallScreen from './SmallScreen'
import LargeScreen from './LargeScreen'
import { Role } from 'types'

interface IProps {
  userRole: Role
  tanks: object[]
  viewTankInfo: (tankId: string) => void
  typeSelected
}

const ListView = ({ userRole, tanks, viewTankInfo, typeSelected }: IProps) => (
  <div>
    <Hidden mdUp>
      <SmallScreen tanks={tanks} onTankClick={viewTankInfo} />
    </Hidden>
    <Hidden smDown>
      {userRole === Role.ADMIN || userRole === Role.CLT || userRole === Role.CUSTOMER ? (
        <LargeScreen userRole={userRole} tanks={tanks} onTankClick={viewTankInfo} typeSelected={typeSelected} />
      ) : (
        <SmallScreen tanks={tanks} onTankClick={viewTankInfo} />
      )}
    </Hidden>
  </div>
)

export default React.memo(ListView)
